// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3WQJT","amount":"Amount_amount__3mkUE","tip":"Amount_tip__Nu-hA","tipHeader":"Amount_tipHeader__2RYCE","tipsWrap":"Amount_tipsWrap__2-Wl-"};